import {
    ECAPI_TYPE_ACCESSORY,
    ECAPI_TYPE_CAPSULE,
    ECAPI_TYPE_GIFT_CARD,
    ECAPI_TYPE_MACHINE
} from '@kissui/helpers/src/catalog'

export const getSkuComponentByType = ({ type, is_machine_b2b }) => {
    let result = 'nb-sku'

    if (type === ECAPI_TYPE_CAPSULE) {
        result = 'nb-sku-coffee'
    } else if (type === ECAPI_TYPE_MACHINE && is_machine_b2b) {
        result = 'nb-sku-machine-b2b'
    } else if (type === ECAPI_TYPE_MACHINE) {
        result = 'nb-sku-machine'
    } else if (type === ECAPI_TYPE_ACCESSORY) {
        result = 'nb-sku-accessory'
    } else if (type === ECAPI_TYPE_GIFT_CARD) {
        result = 'nb-sku-gift-card'
    }

    return result
}

export const apiOverride = (productData, pageBuilderData) => {
    if (!productData || !pageBuilderData) {
        return {}
    }

    const { images, name, headline, description } = productData
    const { api_override } = pageBuilderData

    if (!api_override) {
        return {}
    }

    return {
        image: api_override.image || images?.icon || images?.url || images?.push || images?.main,
        name: api_override.name || name,
        headline: api_override.headline || headline,
        description: api_override.description || description
    }
}
